import { useCallback, useEffect, useState } from 'react'
import { useStore } from 'react-redux'
import { getOne } from '../helper/baseFetch'
import { API_PATH } from '../Constants/path'

/**
 * Custom hook to fetch and manage survey data
 * Handles loading, error states, and data transformations
 */
export const useSurveyData = (surveyId) => {
  const store = useStore()
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchSurveyData = useCallback(() => {
    if (!surveyId) return Promise.resolve(null)

    setLoading(true)
    setError(null)

    return new Promise((resolve, reject) => {
      getOne(
        `${API_PATH.survey.detail}/${surveyId}`,
        undefined,
        (result) => {
          const filteredResult = {
            ...result,
            questionList: result?.questionList?.sort((a, b) => a.sequence - b.sequence),
          }
          setData(filteredResult)
          setLoading(false)
          resolve(filteredResult)
        },
        (err) => {
          setError(err)
          setLoading(false)
          reject(err)
        },
        store
      )
    })
  }, [surveyId, store])

  useEffect(() => {
    fetchSurveyData()
  }, [fetchSurveyData])

  return { data, loading, error, refetch: fetchSurveyData }
}
